import { PaymentPlanHistoryItem } from '@frontend/api-payment-plans';
import { MarkIcon, RefundIcon, SearchIcon, UnmarkIcon } from '@frontend/design-system';
import { isPlanScheduled } from '../../../utils/payment-plan-helpers';

export const getPaymentsPlanHistoryActions = (
  t: (key: string) => string,
  setSelectedPayment: (payment: PaymentPlanHistoryItem) => void,
  viewPaymentTriggerProps: any,
  navigate: any,
  toggleRecorded: any
) => [
  {
    label: t('View payment details'),
    Icon: SearchIcon,
    onClick: (payment: PaymentPlanHistoryItem) => {
      setSelectedPayment(payment);
      viewPaymentTriggerProps.onClick();
    },
    trackingId: 'pay-portal-paymentplan-btn-details',
  },
  {
    label: t('Refund the payment'),
    Icon: RefundIcon,
    onClick: (payment: PaymentPlanHistoryItem) =>
      payment?.payment?.id
        ? navigate({ to: '/payments/invoices/$id', params: { id: payment.payment?.id } })
        : navigate({ to: '/payments/invoices' }),
    trackingId: 'pay-portal-paymentplan-btn-refund',
    hide: (data: PaymentPlanHistoryItem) => isPlanScheduled(data),
  },
  {
    label: t('Mark as recorded'),
    Icon: MarkIcon,
    onClick: (data: PaymentPlanHistoryItem) =>
      toggleRecorded({
        data,
        recordedAt: data?.payment?.recordedAt,
        paymentId: data?.payment?.paymentId,
      }),
    hide: (data: PaymentPlanHistoryItem) => !!data?.payment?.recordedAt || isPlanScheduled(data),
    trackingId: 'pay-portal-paymentplan-btn-recorded',
  },
  {
    label: t('Mark as unrecorded'),
    Icon: UnmarkIcon,
    onClick: (data: PaymentPlanHistoryItem) =>
      toggleRecorded({
        data,
        recordedAt: data?.payment?.recordedAt,
        paymentId: data?.payment?.paymentId,
      }),
    hide: (data: PaymentPlanHistoryItem) => !data.payment?.recordedAt || isPlanScheduled(data),
    trackingId: 'pay-portal-paymentplan-btn-unrecorded',
  },
];
